<script setup lang="ts">
import {EVENT_DATE_FORMAT, type IScheduledEvent} from "~/data/events";
import LeftDays from "~/components/partials/LeftDays.vue";
import {isDone} from "~/functions/isDone";
import {useEventTZDate} from "~/computed/useEventTZDate";
import moment from "moment-timezone";

const $props = defineProps<{
  scheduledEvent: IScheduledEvent,
  isDone: boolean
}>();

const isEventDone = isDone($props.scheduledEvent);
const eventDate = useEventTZDate($props.scheduledEvent);
</script>

<template>
  <li>
    <nuxt-link
      class="link black underline-violet hover-violet"
      :class="{done: isEventDone}"
      :to="scheduledEvent.url"
    >
      <span class="date-wrapper">
        <span class="date">{{ eventDate.startDateString }} <span class="small">(МСК)</span></span>
        <left-days :scheduledEvent="scheduledEvent" />
      </span>

      <span class="title">{{ scheduledEvent.title }}</span>
      <span class="description" v-if="!!scheduledEvent.description">{{ scheduledEvent.description }}</span>
      <span class="go-to" v-if="!scheduledEvent?.hideOlineVideo">{{ !$props.isDone ? 'Подробнее' : 'Смотреть запись' }} <Icon :name="!$props.isDone ? 'icon-arrow-right' : 'icon-video'"/></span>
    </nuxt-link>
  </li>
</template>

<style scoped lang="scss">

</style>